import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { SearchIcon } from "components/common/Icons/SearchIcon";
import { useFontList } from "../useFontList";

interface FontSearchProps {
    search: ReturnType<typeof useFontList>["search"];
    handleSearch: ReturnType<typeof useFontList>["handleSearch"];
}

export const FontSearch = ({ search, handleSearch }: FontSearchProps) => {
    return (
        <div className="bg-irGray-200 dark:bg-darkSurface-300 flex items-center gap-2 mx-2 mb-4 pl-4 rounded-xl">
            <div>
                <SearchIcon />
            </div>
            <input
                className="w-full h-full py-3 bg-transparent outline-none focus:outline-none"
                placeholder={capitalize(translateFunc("search"))}
                value={search}
                onChange={handleSearch}
            />
        </div>
    );
};
